/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_DescriptionInputs */

const id_notifications_description = /** @type {(inputs: Notifications_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konfigurasi dan kelola notifikasi push untuk pembaruan Epic Games Store, rilis game, dan peringatan yang dipersonalisasi.`)
};

const ms_notifications_description = /** @type {(inputs: Notifications_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konfigurasi dan urus pemberitahuan push untuk kemas kini Epic Games Store, keluaran permainan, dan makluman diperibadikan.`)
};

const da_notifications_description = /** @type {(inputs: Notifications_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konfigurér og administrér push-notifikationer for Epic Games Store opdateringer, spiludgivelser og personlige alarmer.`)
};

const de_notifications_description = /** @type {(inputs: Notifications_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konfigurieren und verwalten Sie Push-Benachrichtigungen für Epic Games Store-Updates, Spielveröffentlichungen und personalisierte Benachrichtigungen.`)
};

const en_us2_notifications_description = /** @type {(inputs: Notifications_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configure and manage push notifications for Epic Games Store updates, game releases, and personalized alerts.`)
};

const es_es2_notifications_description = /** @type {(inputs: Notifications_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configura y administra notificaciones push para actualizaciones de la Epic Games Store, lanzamientos de juegos y alertas personalizadas.`)
};

const es_mx2_notifications_description = /** @type {(inputs: Notifications_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configura y administra notificaciones push para actualizaciones de la Epic Games Store, lanzamientos de juegos y alertas personalizadas.`)
};

const fil_notifications_description = /** @type {(inputs: Notifications_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I-configure at pamahalaan ang mga push notification para sa mga update ng Epic Games Store, paglabas ng laro, at mga personalized na alerto.`)
};

const fr_notifications_description = /** @type {(inputs: Notifications_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurez et gérez les notifications push pour les mises à jour de l'Epic Games Store, les sorties de jeux et les alertes personnalisées.`)
};

const it_notifications_description = /** @type {(inputs: Notifications_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configura e gestisci le notifiche push per gli aggiornamenti dell'Epic Games Store, le uscite di giochi e gli avvisi personalizzati.`)
};

const hu_notifications_description = /** @type {(inputs: Notifications_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push értesítések konfigurálása és kezelése az Epic Games Store frissítéseihez, játékmegjelenésekhez és személyre szabott figyelmeztetésekhez.`)
};

const nl_notifications_description = /** @type {(inputs: Notifications_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pushmeldingen configureren en beheren voor Epic Games Store-updates, gamereleases en gepersonaliseerde waarschuwingen.`)
};

const no_notifications_description = /** @type {(inputs: Notifications_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konfigurer og administrer push-varsler for Epic Games Store-oppdateringer, spillutgivelser og personlige varsler.`)
};

const pl_notifications_description = /** @type {(inputs: Notifications_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konfiguruj i zarządzaj powiadomieniami push dla aktualizacji Epic Games Store, premier gier i spersonalizowanych alertów.`)
};

const pt_br2_notifications_description = /** @type {(inputs: Notifications_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configure e gerencie notificações push para atualizações Epic Games Store, lançamentos de jogos e alertas personalizados.`)
};

const pt_notifications_description = /** @type {(inputs: Notifications_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configure e gerencie notificações push para atualizações da Epic Games Store, lançamentos de jogos e alertas personalizados.`)
};

const ro_notifications_description = /** @type {(inputs: Notifications_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurează și gestionează notificările push pentru actualizări Epic Games Store, lansări de jocuri și alerte personalizate.`)
};

const fi_notifications_description = /** @type {(inputs: Notifications_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Määritä ja hallitse push-ilmoituksia Epic Games Store -päivityksille, pelijulkaisuille ja henkilökohtaisille hälytyksille.`)
};

const sv_notifications_description = /** @type {(inputs: Notifications_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konfigurera och hantera push-notiser för Epic Games Store-uppdateringar, spelrelease och personliga aviseringar.`)
};

const vi_notifications_description = /** @type {(inputs: Notifications_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cấu hình và quản lý thông báo đẩy cho các cập nhật Epic Games Store, bản phát hành game và cảnh báo cá nhân hóa.`)
};

const tr_notifications_description = /** @type {(inputs: Notifications_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store güncellemeleri, oyun çıkışları ve kişiselleştirilmiş uyarılar için push bildirimlerini yapılandırın ve yönetin.`)
};

const cs_notifications_description = /** @type {(inputs: Notifications_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nakonfigurujte a spravujte push oznámení pro aktualizace Epic Games Store, vydání her a personalizované výstrahy.`)
};

const bg_notifications_description = /** @type {(inputs: Notifications_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Конфигурирайте и управлявайте push известия за актуализации на Epic Games Store, издания на игри и персонализирани сигнали.`)
};

const ru_notifications_description = /** @type {(inputs: Notifications_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройте push-уведомления для обновлений Epic Games Store, релизов игр и персонализированных оповещений.`)
};

const uk_notifications_description = /** @type {(inputs: Notifications_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Налаштовуйте та керуйте push-сповіщеннями для оновлень Epic Games Store, релізів ігор та персоналізованих попереджень.`)
};

const ar_notifications_description = /** @type {(inputs: Notifications_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تكوين وإدارة الإشعارات الفورية لتحديثات Epic Games Store وإصدارات الألعاب والتنبيهات المخصصة.`)
};

const hi_notifications_description = /** @type {(inputs: Notifications_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store अपडेट, गेम रिलीज़ के लिए पुश सूचनाएँ कॉन्फ़िगर करें।`)
};

const th_notifications_description = /** @type {(inputs: Notifications_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำหนดค่าและจัดการการแจ้งเตือนแบบพุชสำหรับการอัปเดต Epic Games Store การวางจำหน่ายเกม และการแจ้งเตือนเฉพาะบุคคล`)
};

const ja_notifications_description = /** @type {(inputs: Notifications_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store の更新、ゲームリリース、パーソナライズされたアラートのプッシュ通知を設定・管理。`)
};

const zh_cn2_notifications_description = /** @type {(inputs: Notifications_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`配置并管理关于Epic游戏商城更新、游戏发布及个性化提醒的推送通知。`)
};

const zh_hant1_notifications_description = /** @type {(inputs: Notifications_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`設定並管理關於Epic遊戲商城更新、遊戲發布及個人化提醒的推播通知。`)
};

const ko_notifications_description = /** @type {(inputs: Notifications_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store 업데이트, 게임 출시 및 개인화된 알림에 대한 푸시 알림을 구성하고 관리합니다.`)
};

/**
* | output |
* | --- |
* | "Configure and manage push notifications for Epic Games Store updates, game releases, and personalized alerts." |
*
* @param {Notifications_DescriptionInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_description = /** @type {((inputs?: Notifications_DescriptionInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_DescriptionInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_description(inputs)
	if (locale === "ms") return ms_notifications_description(inputs)
	if (locale === "da") return da_notifications_description(inputs)
	if (locale === "de") return de_notifications_description(inputs)
	if (locale === "en-US") return en_us2_notifications_description(inputs)
	if (locale === "es-ES") return es_es2_notifications_description(inputs)
	if (locale === "es-MX") return es_mx2_notifications_description(inputs)
	if (locale === "fil") return fil_notifications_description(inputs)
	if (locale === "fr") return fr_notifications_description(inputs)
	if (locale === "it") return it_notifications_description(inputs)
	if (locale === "hu") return hu_notifications_description(inputs)
	if (locale === "nl") return nl_notifications_description(inputs)
	if (locale === "no") return no_notifications_description(inputs)
	if (locale === "pl") return pl_notifications_description(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_description(inputs)
	if (locale === "pt") return pt_notifications_description(inputs)
	if (locale === "ro") return ro_notifications_description(inputs)
	if (locale === "fi") return fi_notifications_description(inputs)
	if (locale === "sv") return sv_notifications_description(inputs)
	if (locale === "vi") return vi_notifications_description(inputs)
	if (locale === "tr") return tr_notifications_description(inputs)
	if (locale === "cs") return cs_notifications_description(inputs)
	if (locale === "bg") return bg_notifications_description(inputs)
	if (locale === "ru") return ru_notifications_description(inputs)
	if (locale === "uk") return uk_notifications_description(inputs)
	if (locale === "ar") return ar_notifications_description(inputs)
	if (locale === "hi") return hi_notifications_description(inputs)
	if (locale === "th") return th_notifications_description(inputs)
	if (locale === "ja") return ja_notifications_description(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_description(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_description(inputs)
	return ko_notifications_description(inputs)
});
export { notifications_description as "notifications.description" }